import React, { useEffect } from "react";
import PhaseDetails from "../PhaseDetails/PhaseDetails";
import useUserInfo from "../../Hooks/useUserInfo";
import "../PhaseDetails/PhaseDetails.css";
import Tv from "../Tv/Tv";
import cancelIcon from "../../assets/Task/cancelicon.svg";
import Totalpoints from "../TotalPoints/TotalPoints";
import { logPageView } from "../../components/analytics";

const Info = () => {
  const { userDetails, updateUserInfo } = useUserInfo();
  useEffect(() => {
    logPageView("StakeDetails", "StakeDetails page");
  }, []);
  const toogleMenu = () => {
    updateUserInfo((prev) => ({
      ...prev,
      isPlay: false,
      currentComponent: Totalpoints,
      currentComponentText: "TotalpointsPage",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
      isMenu: false,
      menuCount: userDetails?.userDetails?.menuCount + 1,
    }));
  };

  return (
    <div className="info-img">
      <img
        onClick={() => {
          toogleMenu();
        }}
        src='https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg'
        className="cancel-imgpoints"
        style={{ cursor: "pointer", pointerEvents: "all" }}
      />

      <div
        className="menupointer "
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          pointerEvents: "all",
        }}
      >
        <div style={{ maxWidth: "380px" }}>
          <div className="phase-details">
            <h3>Here’s how it works</h3>
          </div>
          <div className="phase-para1">
            <p className="font-2">
              doNothing, <br />
              YOU GET TOKENS
            </p>
            <p className="font-2">
              TAP, <br />
              YOU GET TOKENS
            </p>
            <p className="font-2">
              PLAY GAMES, <br />
              YOU GET TOKENS
            </p>
            <p className="font-2">
              MAINTAIN STREAK, <br />
              YOU GET TOKENS
            </p>
            <p className="font-2">
              STAKE, <br />
              YOU GET TOKENS
            </p>
            <h3 className="fonth3">REPEAT !!!</h3>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Info;
